module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "locations-content"
    }
  }, [_c('div', {
    class: {
      indicators: _vm.$route.name === 'indicators', hidden: !_vm.visible, expanded: _vm.selectedEngagement
    },
    attrs: {
      "id": "saved-view"
    }
  }, [_c('label', {
    attrs: {
      "id": "toggle-hidden"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visible),
      expression: "visible"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.visible) ? _vm._i(_vm.visible, null) > -1 : (_vm.visible)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.visible,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.visible = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.visible = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.visible = $$c
        }
      }
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.$route.name === 'locations' && !_vm.saveForm) ? _c('div', [_vm._m(1), _vm._v(" "), _c('mill-list', {
    attrs: {
      "mills": _vm.mills
    },
    on: {
      "millClick": _vm.toggleSelectedMill
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "button hollow save-view-btn",
    attrs: {
      "disabled": _vm.selectedMills.length === 0
    },
    on: {
      "click": function($event) {
        _vm.saved = true;
        _vm.saveForm = true;
        _vm.setMapImage('static-zoom-in2.png')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" Save As View\n        ")])])], 1) : _c('div', [(_vm.$route.name !== 'indicators' && _vm.$route.name !== 'savedViews') ? _c('div', [_c('div', {
    staticClass: "location-section"
  }, [_c('h4', [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" Mill Locator")]), _vm._v(" "), _c('div', [_vm._v("Please provide a name to save this view.")])]), _vm._v(" "), _c('div', {
    staticClass: "location-section white"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.savedViewName),
      expression: "savedViewName"
    }],
    staticClass: "input-group-field",
    attrs: {
      "type": "text",
      "placeholder": "Name this view"
    },
    domProps: {
      "value": (_vm.savedViewName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.savedViewName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-button",
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_c('router-link', {
    staticClass: "button",
    attrs: {
      "to": {
        name: 'indicators'
      }
    }
  }, [_vm._v("\n                Save\n              ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "composite-score"
  }, [_vm._v("\n            This view's composite score: " + _vm._s(_vm.compositeScore) + "%\n            "), _c('i', {
    staticClass: "fa fa-check"
  })])])]) : (_vm.$route.name === 'savedViews') ? _c('div', [_c('div', {
    staticClass: "location-section saved-view-header"
  }, [_c('h4', [_c('i', {
    staticClass: "fa fa-bookmark"
  }), _vm._v(" My Saved Views")]), _vm._v(" "), _c('div', [_vm._v("You have 1 saved landscape")])]), _vm._v(" "), _c('div', {
    staticClass: "location-section white"
  }, [_c('h6', [_c('i', {
    staticClass: "fa fa-bookmark"
  }), _vm._v(" " + _vm._s(_vm.savedViewName))]), _vm._v(" "), _c('div', {
    staticClass: "composite-score"
  }, [_vm._v("\n            This view's composite score: " + _vm._s(_vm.compositeScore) + "%\n            "), _c('i', {
    staticClass: "fa fa-check"
  })])])]) : (!_vm.selectedEngagement) ? _c('div', {
    staticClass: "engagements"
  }, [_c('h4', [_vm._v("Engagement Opportunities")]), _vm._v(" "), _vm._l((_vm.$store.state.engagements), function(engagement) {
    return (_vm.engagementActive(engagement.indicators)) ? _c('div', {
      staticClass: "engagement"
    }, [(engagement.image) ? _c('img', {
      attrs: {
        "src": _vm.loadImg(engagement.image)
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "engagement-content"
    }, [_c('h5', {
      on: {
        "click": function($event) {
          engagement.active = !engagement.active
        }
      }
    }, [_vm._v("\n              " + _vm._s(engagement.title) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "selected-indicators"
    }, _vm._l((engagement.indicators), function(oi) {
      return _c('div', [_vm._v("\n                " + _vm._s(oi) + "\n                "), _c('div', {
        staticClass: "stars"
      }, _vm._l((4), function(i) {
        return _c('i', {
          staticClass: "fa fa-circle-o",
          class: {
            active: i <= _vm.getIndicator(oi).oppLevel
          }
        })
      }))])
    })), _vm._v(" "), _c('i', {
      staticClass: "fa fa-heart",
      class: {
        active: engagement.heart
      },
      on: {
        "click": function($event) {
          engagement.heart = !engagement.heart
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa",
      class: {
        'fa-chevron-up': engagement.active, 'fa-chevron-down': !engagement.active
      },
      on: {
        "click": function($event) {
          engagement.active = !engagement.active
        }
      }
    }), _vm._v(" "), (engagement.active) ? _c('div', {
      staticClass: "engagement-description"
    }, [_vm._v("\n              " + _vm._s(engagement.excerpt) + "\n              "), _c('div', {
      staticClass: "engagement-details"
    }, [_c('a', {
      attrs: {
        "href": engagement.link
      }
    }, [_vm._v("Link")]), _vm._v(" "), _c('button', {
      staticClass: "button tiny",
      on: {
        "click": function($event) {
          _vm.selectedEngagement = engagement
        }
      }
    }, [_vm._v("\n                  Read More\n                ")]), _vm._v(" "), (engagement.donations) ? _c('button', {
      staticClass: "button tiny"
    }, [_vm._v("Donate")]) : _vm._e()])]) : _vm._e()])]) : _vm._e()
  })], 2) : (_vm.selectedEngagement) ? _c('div', {
    staticClass: "engagements selected-engagement"
  }, [_c('div', {
    staticClass: "engagement-content"
  }, [_c('h4', [_vm._v(_vm._s(_vm.selectedEngagement.title))]), _vm._v(" "), _c('div', {
    staticClass: "engagement-description",
    domProps: {
      "innerHTML": _vm._s(_vm.selectedEngagement.description)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "engagement-sidebar"
  }, [_c('button', {
    staticClass: "back button",
    on: {
      "click": function($event) {
        _vm.selectedEngagement = null
      }
    }
  }, [_vm._v("Back to Engagement Opportunities")]), _vm._v(" "), _c('h5', [_vm._v("Engagement Indicators")]), _vm._v(" "), _c('div', {
    staticClass: "selected-indicators"
  }, _vm._l((_vm.selectedEngagement.indicators), function(oi) {
    return _c('div', [_c('span', [_vm._v(_vm._s(oi))]), _vm._v(" "), _c('div', {
      staticClass: "stars"
    }, _vm._l((4), function(i) {
      return _c('i', {
        staticClass: "fa fa-circle-o",
        class: {
          active: i <= _vm.getIndicator(oi).oppLevel
        }
      })
    }))])
  })), _vm._v(" "), _c('h5', [_vm._v("Partner Logos")]), _vm._v(" "), _c('div', {
    staticClass: "engagement-logos"
  }, _vm._l((_vm.selectedEngagement.logos), function(logo) {
    return _c('img', {
      attrs: {
        "src": logo
      }
    })
  })), _vm._v(" "), _c('h5', [_vm._v("Additional Resources")]), _vm._v(" "), _c('div', {
    staticClass: "engagement-details"
  }, [_c('a', {
    attrs: {
      "href": _vm.selectedEngagement.link,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  }), _vm._v(" External Link\n            ")]), _vm._v(" "), (_vm.selectedEngagement.download) ? _c('a', {
    attrs: {
      "href": _vm.selectedEngagement.download
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Download\n            ")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.$route.name !== 'indicators') ? _c('mill-list', {
    attrs: {
      "mills": _vm.selectedMills
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'savedViews') ? _c('div', {
    staticClass: "view-indicators"
  }, [_c('router-link', {
    staticClass: "button",
    attrs: {
      "to": {
        name: 'indicators'
      }
    }
  }, [_vm._v("\n          View Indicators\n        ")])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    class: [{
      indicators: _vm.$route.name === 'indicators'
    }, 'no-stretch'],
    attrs: {
      "id": "map-content"
    }
  }, [_c('div', {
    attrs: {
      "id": "map-wrap"
    }
  }, [(!_vm.saveForm && _vm.$route.name === 'locations') ? _c('div', {
    staticClass: "map-markers"
  }, _vm._l((_vm.mills), function(mill, index) {
    return _c('img', {
      key: index,
      staticClass: "toggle-map-marker",
      style: ({
        top: mill.top,
        left: mill.left
      }),
      attrs: {
        "src": _vm.imageMillSelected(mill)
      },
      on: {
        "click": function($event) {
          _vm.toggleSelectedMill(mill)
        }
      }
    })
  })) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'indicators') ? _c('div', {
    staticClass: "county-trigger",
    attrs: {
      "id": "county-trigger-0"
    },
    on: {
      "click": function($event) {
        _vm.showCountyCards(0)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'indicators') ? _c('div', {
    staticClass: "county-trigger",
    attrs: {
      "id": "county-trigger-1"
    },
    on: {
      "click": function($event) {
        _vm.showCountyCards(1)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "id": "zoom-map-static",
      "src": _vm.mapImage
    },
    on: {
      "click": _vm.hideCountyCards
    }
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.countyCardsActive !== false) ? _c('county-cards', {
    attrs: {
      "id": 'county-cards-container-' + _vm.countyCardsActive,
      "county": _vm.countyCardsActive
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.$route.name !== 'savedViews') ? _c('transition', {
    attrs: {
      "name": "indicators-in-out"
    }
  }, [_c('router-view')], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "location-section"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo-small.png"),
      "alt": "Forests in Focus"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "float-right",
    attrs: {
      "src": require("../assets/logos-conjunction.png"),
      "alt": "Forests in Focus"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "location-section"
  }, [_c('h4', [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" Mill Locator")]), _vm._v(" "), _c('div', [_vm._v("Select Pins Below")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a42601a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Locations.vue
// module id = 115
// module chunks = 0